import { SET_SNACKBAR } from '../actions/SnackBarActions'

function initialState() {
  return {
    classType: '',
    icon: '',
    show: false,
    text: '',
  }
}

export default function snackBarReducer(state = initialState(), action) {
  switch (action.type) {
    case SET_SNACKBAR:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
